import {TypeTimeReports} from "../../../../../../views/reports/time-reports/time-reporting-summary/@const";
import {momentRange} from "../../../../../gd/convert/moment-range";
import formatDaterange from "../../../../../gd/format/daterange";


export default class ReportTimeReportingSummary_Settings {

    public typeView       : TypeTimeReports
    public daterange      : DateRange
    public users          : ID[]
    public totalReported  : boolean
    public requiredReport : boolean
    public workdays       : boolean
    public offDays        : boolean
    public departmentId   : ID


    constructor(data: any) {
        this.typeView       = _.get(data, "typeView", TypeTimeReports.DAILY)
        this.daterange      = data?.daterange ? momentRange(data.daterange.start, data.daterange.end) : momentRange(moment().subtract(1, "month"), moment())
        this.users          = _.get(data, "users", [])
        this.totalReported  = _.get(data, "totalReported", true)
        this.requiredReport = _.get(data, "requiredReport", true)
        this.workdays       = _.get(data, "workdays", true)
        this.offDays        = _.get(data, "offDays", true)
        this.departmentId   = _.get(data, "departmentId", null)
    }

    get reportTitle() {
        let title = ""

        title += formatDaterange(this.daterange)

        return title
    }

    toJSON(): JSONObject {
        const result: JSONObject = {
            typeView       : this.typeView,
            users          : this.users,
            totalReported  : this.totalReported,
            requiredReport : this.requiredReport,
            workdays       : this.workdays,
            offDays        : this.offDays,
            departmentId   : this.departmentId,
        }

        if (this.daterange) {
            result['daterange'] = {
                start   : this.daterange.start.format("YYYY-MM-DD"),
                end     : this.daterange.end.format("YYYY-MM-DD")
            }
        }

        return result
    }
}
